<div class="loader-container" [ngClass]="overlayState ? '' : 'loading-index'" *ngIf="loading || overlayState">
    <img id="loaderImg" *ngIf="loading" class="loader-img" src="assets/images/loader.svg" alt="loading...">
</div>

<app-email-cognito-form *ngIf="isTokenValid" [formId]="cogFormId" [cogFormPrefillData]="formData"></app-email-cognito-form>

<div *ngIf="successMessage" class="alert alert-success">
    {{ successMessage }}
</div>
<div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
</div>